import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202507: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202507",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-07-01",
  endDate: "2025-07-31",
  impressions: 51848,
  clicks: 1103,
  adsSpendDollars: 1599,
  budgetDollars: 1800,
  salesDollars: 3820,
  bestEstimateRoas: 2.39,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.89,
  newCustomersAcquired: 16,
  dataAvailableAtDate: "2025-08-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
